
export function notification(message, target = $('.notification')){
	console.log(message);
	target
	.html(message)
	.fadeIn(300)
	.delay(4000) // Pauses for 4 seconds
	.fadeOut(300)
	.delay(300);
	
}